import {combineEpics, createEpicMiddleware} from 'redux-observable'
import {AuthObservable} from 'auth-advenio'
import {COOKIE_DOMAIN} from '../../config'
import Api from '../Api'
import {classroomEpic} from './ClassroomObservable'
import {healthCheckEpic} from './HealthCheckObservable'
import {healthTeacherEpic} from './HealthTeacherObservable'
import {inventoryEpic} from './InventoryObservable'
import {cardsEpic} from './CardsObserver'
import {centerEpic} from './CenterObservable'
import {centerClassroomEpic} from './CenterClassroomObservable'
import {contractsEpic} from './ContractsObservable'
import {inscriptionsEpic} from './InscriptionsObservable'
import {activityEpic} from './ActivityObservable'
import {paymentRemindersEpic} from './PaymentRemindersObservable'
import {StudyProgramsEpic} from './StudyProgramsObservable'
import {disenrollmentCategoriesEpic} from './DisenrollmentCategoriesObservable'
import {documentsEpic} from './DocumentsObservable'
import {childrenEpic} from './ParentPlatform/ChildrenObserver'
import {medicineEpic} from './ParentPlatform/MedicineObserver'
import {paymentsEpic} from './ParentPlatform/PaymentsObservable'
import {reservationEpic} from './ParentPlatform/ReservationObserver'
import {reservationBmxEpic} from './ReservationBmxObserver'
import {disenrollmentsEpic} from './DisenrollmentsObservable'
import {enrollEpic} from './EnrollObservable'
import {CenterProductsEpic} from './CenterProductsObservable'
import {reservedEnrollmentsEpic} from './ReservedEnrollmentsObservable'
import {reEnrollEpic} from './ReEnrollObservable'
import {reservedEpic} from './ReservedObservable'
import {reEnrollmentsEpic} from './ReEnrollmentsObservable'
import {reEnrollFromDisenrollmentsEpic} from './ReEnrollFromDisenrollmentsObservable'
import {medicinesCenterEpic} from './MedicinesCenterObservable'
import {checkinInventoryEpic} from './CheckinInventoryObservable'
import {consumablesEpic} from './ConsumablesObservable'
import {consumablesCategoriesEpic} from './ConsumablesCategoriesObservable'
import {balanceEpic} from './BalanceObservable'
import {paymentTypesEpic} from './PaymentTypesObservable'
import {paymentTypesMsiEpic} from './PaymentTypesMsiObservable'
import {serviceTypesEpic} from './ServiceTypesObservable'
import {ratingEpic} from './ParentPlatform/RatingObserver'
import {balanceEpic as parent_platform_balance_epic} from './ParentPlatform/BalanceObservable'
import {notificationsEpic} from './NotificationsObservable'
import {companiesEpic} from './CompaniesObservable'
import {relationsEpic} from './RelationsObservable'
import {centerOptionsEpic} from './CenterOptionsObservable'
import {financesEpic} from './FinancesObservable'
import {ratingsEpic} from './RatingsObservable'
import {checkinsEpic} from './CheckinsObservable'
import {attendanceEpic} from './AttendanceObservable'
import {dailyAttendanceEpic} from './DailyAttendanceObservable'
import {domiciliationReportEpic} from './DomiciliationReportObservable'
import {assistanceEpic} from './AssistanceObservable'
import {averageAttendanceEpic} from './AverageAttendanceObservable'
import {visitAverageAttendanceEpic} from './VisitAverageAttendanceObservable'
import {totalAttendanceEpic} from './TotalAttendanceObservable'
import {centerVisitAverageEpic} from './CenterVisitAverageObservable'
import {studentCheckinEpic} from './StudentCheckinObservable'
import {demographicsEpic} from './DemographicsObservable'
import {overviewEpic} from './OverviewObservable'
import {incidentEpic} from './IncidentObservable'
import {allCentersEpic} from './AllCentersObservable'
import {addEpic} from './AddSiblingObservable'
import {ParentPaymentTypesEpic} from './ParentPaymentTypesObservable'
import {CountriesEpic} from './CountriesObservable'
import {EmergencyMedicationsEpic} from './EmergencyMedicationsObservable'
import {IncidentTypesEpic} from './IncidentTypesObservable'
import {MoodEpic} from './MoodObservable'
import {ProgramLevelsEpic} from './ProgramLevelsObservable'
import {netEpic} from './NetObservable'
import {motivesEpic} from './MotivesObservable'
import {enrollmentsCategoriesEpic} from './EnrollmentsCategoriesObservable'
import {teacherDistributionEpic} from './TeacherDistributionObservable'
import {activeCheckinsEpic} from './ActiveCheckinsObservable'
import {unitKeysEpic} from './UnitKeysObservable'
import {centersInfoEpic} from './CentersInfoObservable'
import {centersExcelEpic} from './CentersExcelObservable'
import {AdvancedSearchEpic} from './AdvancedSearchObservable'
import {resetPasswordEpic} from './ResetPasswordObservable'
import {unvalidatedPhotosEpic} from './UnvalidatedPhotosObservable'
import {unvalidatedReceiptsEpic} from './UnvalidatedReceiptsObservable'
import {validatedReceiptsEpic} from './ValidatedReceiptsObservable'
import {StudentPhotosEpic} from './ParentPlatform/PhotosObservable'
import {HomeReportEpic} from './ParentPlatform/HomeReportObservable'
import {coursesEpic} from './CoursesObservable'
import {RegimenFiscalEpic} from './RegimenFiscalObservable'
import {UsoCFDIEpic} from './UsoCFDIObservable'
import {usersEpic} from './UsersObservable'
import {enrollmentreportEpic} from './EnrollmentReportObservable'
import {disenrollmentreportEpic} from './DisenrollmentReportObservable'
import {masterlistreportEpic} from './MasterListReportObservable'
import {receiptreportEpic} from './ReceiptReportObservable'
import {medalliaEpic} from "./MedalliaObservable";
import {ServiceOccasionalEpic} from './ServiceOccasionalObservable'
import {historicalEpic} from './HistoricalObservable'
import {evaluationEpic} from "./EvaluationObservable";

const {authEpic} = AuthObservable
const rootEpic = combineEpics(
  activityEpic,
  authEpic(COOKIE_DOMAIN),
  balanceEpic,
  cardsEpic,
  centerEpic,
  centerClassroomEpic,
  CenterProductsEpic,
  checkinInventoryEpic,
  childrenEpic,
  classroomEpic,
  companiesEpic,
  consumablesEpic,
  consumablesCategoriesEpic,
  contractsEpic,
  CountriesEpic,
  disenrollmentCategoriesEpic,
  disenrollmentsEpic,
  documentsEpic,
  enrollEpic,
  EmergencyMedicationsEpic,
  healthCheckEpic,
  healthTeacherEpic,
  IncidentTypesEpic,
  inventoryEpic,
  inscriptionsEpic,
  MoodEpic,
  medicineEpic,
  medicinesCenterEpic,
  notificationsEpic,
  parent_platform_balance_epic,
  paymentRemindersEpic,
  paymentTypesEpic,
  paymentTypesMsiEpic,
  reservationBmxEpic,
  serviceTypesEpic,
  reservationEpic,
  ParentPaymentTypesEpic,
  ProgramLevelsEpic,
  ratingEpic,
  reservedEnrollmentsEpic,
  reEnrollEpic,
  reservedEpic,
  reEnrollmentsEpic,
  reEnrollFromDisenrollmentsEpic,
  StudyProgramsEpic,
  relationsEpic,
  centerOptionsEpic,
  financesEpic,
  ratingsEpic,
  checkinsEpic,
  attendanceEpic,
  centerVisitAverageEpic,
  studentCheckinEpic,
  demographicsEpic,
  overviewEpic,
  incidentEpic,
  allCentersEpic,
  addEpic,
  paymentsEpic,
  dailyAttendanceEpic,
  domiciliationReportEpic,
  averageAttendanceEpic,
  totalAttendanceEpic,
  visitAverageAttendanceEpic,
  netEpic,
  motivesEpic,
  enrollmentsCategoriesEpic,
  teacherDistributionEpic,
  activeCheckinsEpic,
  unitKeysEpic,
  centersInfoEpic,
  centersExcelEpic,
  AdvancedSearchEpic,
  resetPasswordEpic,
  unvalidatedPhotosEpic,
  unvalidatedReceiptsEpic,
  validatedReceiptsEpic,
  StudentPhotosEpic,
  HomeReportEpic,
  assistanceEpic,
  coursesEpic,
  RegimenFiscalEpic,
  usersEpic,
  UsoCFDIEpic,
  enrollmentreportEpic,
  disenrollmentreportEpic,
  masterlistreportEpic,
  receiptreportEpic,
  medalliaEpic,
  ServiceOccasionalEpic,
  historicalEpic,
  evaluationEpic,
)

export default createEpicMiddleware(rootEpic, {
  dependencies: {Api},
})



// WEBPACK FOOTER //
// ./src/Data/Observables/index.js